import { createAsync, query, A, revalidate } from "@solidjs/router";
import { createEffect, createSignal, For, Show } from "solid-js";
import { formattedTimestamp, verifyUser } from "~/lib";
import { schemeChip } from "~/lib/schemeChip";

const getApplyingUsers = query( async () => {
	const { runRecordByStatusQueryServer } = await import( "~/_server/dynamoQueries" );

	return await runRecordByStatusQueryServer( "USER", "applying" );
}, "getApplyingUsers" );

export const Verify = ( props: any ) => {
	const applyingUsers = createAsync( () => getApplyingUsers(), { deferStream: true } );

	return (
		<div class="white-box space-y-4">
			<h1 class="text-xl font-bold mb-4">Verification</h1>

			<ul class="admin-list">
					<For each={applyingUsers()?.items.sort( ( a, b ) => b.registered - a.registered )}>
						{user => (
							<li class="admin-row">
								<div class="admin-main">
									<div>
										<A href={`/dashboard/admin/users/${user.userId}`} class="admin-name text-indigo-600 hover:text-indigo-900">{user.name}</A>
										<span class={`ml-2 inline-block rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide align-middle ${schemeChip( user.targetScheme ).classes}`}>
											{schemeChip( user.targetScheme ).label}
										</span>
									</div>
									<p class="admin-sub">{user.address?.company}</p>
									<p class="admin-meta">Registered {formattedTimestamp( user.registered, { day: "2-digit", month: "short", year: "2-digit" } )}</p>
								</div>
								<div class="admin-aside">
									<VerifyButton userId={user.userId} onVerified={() => revalidate( 'getApplyingUsers' )} />
								</div>
							</li>
						)}
					</For>
				</ul>
		</div>
	);
}


export const VerifyButton = ( props: any ) => {
	const [running, setRunning] = createSignal<boolean>( false );
	const [error, setError] = createSignal<string | null>( null );

	const verify = async () => {
		setRunning( true );
		setError( null );

		try {
			const r = await verifyUser( props.userId );

			if ( r?.success ) {
				props.onVerified?.();
			} else {
				setError( r?.error ?? "Verification failed. Please try again." );
			}
		} catch ( err ) {
			console.error( "Error verifying user", err );
			setError( "Verification failed. Please try again." );
		} finally {
			setRunning( false );
		}
	}

	return (
		<div class="flex flex-col items-end gap-1">
			<button onClick={verify}
				disabled={running()}
				type="button"
				class="rias rias-primary">
				Verify
				<Show when={running()}>
					<svg class="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
						<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
						<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
					</svg>
				</Show>
			</button>
			<Show when={error()}>
				<p class="text-xs text-red-600 max-w-50 text-right">{error()}</p>
			</Show>
		</div>
	);
}